import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { playNotificationSound } from '../../utils/sound';
import { WIDGET_STATE } from '../../constants/app';
import ProactiveMessage from './proactive-message';
import { activateMessage, fetchProactiveMessages, clearExpiredMessages } from '../../actions/bookboost/proactive-message-actions';

import * as tracker from '../../actions/bookboost/tracker';
import isMobileDevice from '../../utils/bookboost/isMobileDevice';

export class ProactiveMessages extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        activeMessages: PropTypes.array.isRequired,
        inactiveMessages: PropTypes.array.isRequired,
        widgetState: PropTypes.symbol.isRequired,
        pmConfig: PropTypes.object.isRequired,
    };

    constructor() {
        super();
        this.welcomeTimers = [];
        this.exitTriggers = [];
    }

    onExitIntent() {
        this.exitTriggers.forEach((trigger) => trigger());
        this.exitTriggers = [];
    }

    async loadProactiveMessages() {
        const { dispatch } = this.props;
        dispatch(clearExpiredMessages());

        const proactiveMessages = await dispatch(fetchProactiveMessages());

        const shouldTrigger = ({ id }) => this.props.activeMessages.every((m) => m.id !== id);

        // We don't want to retrigger messages.
        const proactiveMessagesToTrigger = proactiveMessages.filter(shouldTrigger);

        const execute = (id) => {
            // TODO: Move all trigger logic to reducer.

            const available = this.props.inactiveMessages.some((m) => m.id === id);
            // This condition prevents triggers during exit transition.
            const inTransition = this.props.widgetState === WIDGET_STATE.OPENED;

            if (!inTransition && available) {
                dispatch(tracker.pmFired(id));
                dispatch(activateMessage(id));
                playNotificationSound();
            }
        };

        this.welcomeTimers = proactiveMessagesToTrigger
            .filter((m) => m.trigger.type === 'welcome')
            .map(({ id, trigger }) => setTimeout(execute.bind(this, id), trigger.timeout * 1000));

        this.exitTriggers = proactiveMessagesToTrigger
            .filter((m) => m.trigger.type === 'exit')
            .map(({ id }) => execute.bind(this, id));
    }

    handleMouseleave = (e) => {
        if (e.clientY <= 0) {
            this.onExitIntent();
        }
    }

    componentDidMount() {
        if (parent) {
            parent.window.document.documentElement.addEventListener('mouseleave', this.handleMouseleave);
        }
        this.loadProactiveMessages();
    }

    componentWillUnmount() {
        if (parent) {
            parent.window.document.documentElement.removeEventListener('mouseleave', this.handleMouseleave);
        }
        this.welcomeTimers.forEach((timer) => clearTimeout(timer));
    }

    render() {
        const getLimit = () => {
            return isMobileDevice()
                ? this.props.pmConfig.mobileLimit
                : this.props.pmConfig.desktopLimit;
        };

        const renderMessage = (message) => (
            <ProactiveMessage key={ message.id } message={ message } />
        );

        const renderMessages = (messages) => {
            return messages
                .filter((message) => !message.closed)
                .slice(-getLimit()) // Gets the last messages
                .map(renderMessage);
        };

        // TODO: Animations where removed since they wasn't working with iframe. Fix them!
        return (<span>{ renderMessages(this.props.activeMessages) }</span>);
    }
}

export default connect(({ bbProactiveMessages, appState, bbConfig }) => ({
    activeMessages: bbProactiveMessages.active,
    inactiveMessages: bbProactiveMessages.inactive,
    widgetState: appState.widgetState,
    pmConfig: bbConfig.pmConfig
}))(ProactiveMessages);
